import {IMapItemData} from "../../../../interface";
import {BF4Mapitem} from "./BF4Mapitem";

const ADD_BUTTON_SELECTOR: string = '[data-add-map]';

export class BF4MapcycleUI {
  public constructor(private $base: JQuery) {}

  /**
   * Enable save button
   */
  public enableSaveButton() {
    this.$base.find(ADD_BUTTON_SELECTOR).removeAttr('disabled');
  }

  /**
   * Enable save button
   */
  public onSaveButtonClick(callback: (data: IMapItemData) => void) {
    this.$base.find(ADD_BUTTON_SELECTOR).on('click', (event) => {
      event.preventDefault();
      callback({
        name: this.getMapValue(),
        rounds: this.getRoundsValue(),
        type: this.getTypeValue(),
      });
      return false;
    });
  }

  /**
   * read current map value
   */
  public getMapValue(): string {
    return $('[data-name="maps"]').val() as string;
  }

  /**
   * read current mapType value
   */
  public getTypeValue(): string {
    return $('[data-name="mapTypes"]').val() as string;
  }

  /**
   * read current rounds value
   */
  public getRoundsValue(): string {
    return $('[data-name="mapRounds"]').val() as string;
  }

    /**
     * Render the maps by creating Mapitem instances
     * @param data - array of IMapItemData
     * @param form
     */
  public render(data: IMapItemData[], form: any) {
    this.$base.find('.mapcycle__maps').html('');
    return new Promise((resolve) => {
      data.map((map, i) => {
        map.label = form[0].choices.find(x => x[0] == map.name)[1];
        map.typeLabel = form[1].choices.find(x => x[0] == map.type)[1];
        return new BF4Mapitem({...map, counter: i + 1, index: i}, this.$base);
      });

      resolve();
    })
  }
}
